"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @file fetch current user permissions with json api
var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch a UserPermissions object containing the current user's permissions by user ID in json api format
 * @param id User Id
 * @returns A Promise that resolves to a JsonAPIResponse<UserPermissions>.
 *
 */
function fetchUserPermissions(id) {
  return (0, json_api_fetch_1.jsonApiFetch)("users/".concat(id, "/permissions"));
}
exports.default = fetchUserPermissions;